import { useCartItemsQuery } from "../graphql/schema";

export function useCartItemCount() {
  const { data } = useCartItemsQuery();

  return data?.me.serviceCart?.items.length || 0;
}
